/*
 * Copyright (c) 2023 Trimble Inc. All rights reserved.
 */

import { sendRequestAndReceiveResponse, filterNames, filterModels, toUrlLookupBody } from '../common/common';
import { retrieveServiceBulletinsEndPoint, getServiceBulletinsURLEndPoint } from '../common/constants';

import { getServiceTicketEndpoint } from '../common/constants';
import { loadFromLocalStorage, checkLocalStorageExpiry } from '../common/localStorage';

const UPDATE_FAMILIES = 'UPDATE_FAMILIES';
const SERVICE_BULLETIN_DATA = 'SERVICE_BULLETIN_DATA';
const UPDATE_PRODUCTNAMES = 'UPDATE_PRODUCTNAMES';
const UPDATE_PRODUCTMODELS = 'UPDATE_PRODUCTMODELS';
const UPDATE_ALL_BULLETIN_CLASSIFICATION = 'UPDATE_ALL_BULLETIN_CLASSIFICATION';
const UPDATE_SERIAL_NUMBER = 'UPDATE_SERIAL_NUMBER';
const UPDATE_SELECTED_FAMILY = 'UPDATE_SELECTED_FAMILY';
const UPDATE_SELECTED_PRODUCTNAME = 'UPDATE_SELECTED_PRODUCTNAME';
const UPDATE_SELECTED_PRODUCTMODEL = 'UPDATE_SELECTED_PRODUCTMODEL';
const LOADING_BULLETIN_DETAIL = 'LOADING_BULLETIN_DETAIL';
const LOADING_BULLETIN_DETAIL_DONE = 'LOADING_BULLETIN_DETAIL_DONE';
const SERVICE_BULLETIN_DETAIL = 'SERVICE_BULLETIN_DETAIL';
const UNSELECT_BULLETIN = 'UNSELECT_BULLETIN';
const LOAD_SERVICE_BULLETIN = 'LOAD_SERVICE_BULLETIN';
const STOP_LOADING = 'STOP_LOADING';
const CLEAR_VIEW_BULLETIN_STORE = 'CLEAR_VIEW_BULLETIN_STORE';
const CLEAR_BULLETIN_LIST = 'CLEAR_BULLETIN_LIST';
const UPDATE_BULLETINS = 'UPDATE_BULLETINS';
const LOAD_SERVICE_BULLETIN_NUMBER = 'LOAD_SERVICE_BULLETIN_NUMBER';
const UPDATE_BULLETIN_NUMBER = 'UPDATE_BULLETIN_NUMBER';
const UPDATE_BULLETIN_DATA = 'UPDATE_BULLETIN_DATA';
const initialState = {
    data: {},
    families: [],
    productNames: [],
    productModels: [],
    serialNumber: '',
    bulletinNumber: '',
    isAuthenticatedOnce: false,
    isBulletinLoading: false,

}

export const actionCreators = {

    UpdateProductFamilies: (families: any) => async (dispatch: any, getState: any) => {
        dispatch({ type: UPDATE_FAMILIES, families });

    },
    FilterNames: (Productfamilies: any, selectedProductFamily: any,) => async (dispatch: any, getState: any) => {

        let productNames: any = [];

        productNames = filterNames(Productfamilies, selectedProductFamily);

        dispatch({ type: UPDATE_PRODUCTNAMES, productNames });

    },
    FilterModels: (ProductNames: any, selectedProductName: any,) => async (dispatch: any, getState: any) => {

        let productModels: any = [];
        productModels = filterModels(ProductNames, selectedProductName);
        dispatch({ type: UPDATE_PRODUCTMODELS, productModels });

    },
    UpdateProductClassificationonSerialNumber: (selectedFamily: any, selectedProductName: any, selectedProductModel: any, serviceBulletin: any) => async (dispatch: any, getState: any) => {
        dispatch({ type: UPDATE_ALL_BULLETIN_CLASSIFICATION, selectedFamily, selectedProductName, selectedProductModel, serviceBulletin });
    },
    UpdateBulletins: (serviceBulletin: any) => async (dispatch: any, getState: any) => {
        dispatch({ type: UPDATE_BULLETINS, serviceBulletin });
    },
    UpdateSerialNumber: (serialNumber: any) => async (dispatch: any, getState: any) => {
        dispatch({ type: UPDATE_SERIAL_NUMBER, serialNumber });
    },
    UpdateBulletinNumber: (bulletinNumber: any) => async (dispatch: any, getState: any) => {
        dispatch({ type: UPDATE_BULLETIN_NUMBER, bulletinNumber });
    },
    UpdateSelectedFamily: (selectedFamilies: any) => async (dispatch: any, getState: any) => {
        dispatch({ type: UPDATE_SELECTED_FAMILY, selectedFamilies });
        const serviceBulletinData = await sendRequestAndReceiveResponse(
            JSON.stringify({
                'ClassificationId': selectedFamilies[0],
                'ClassificationType': 'productfamily'
            }), retrieveServiceBulletinsEndPoint);
        console.log(serviceBulletinData);
        dispatch({ type: SERVICE_BULLETIN_DATA, serviceBulletinData });
    },
    UpdateSelectedProductName: (SelectedProductNames: any) => async (dispatch: any, getState: any) => {
        dispatch({ type: UPDATE_SELECTED_PRODUCTNAME, SelectedProductNames });
        const serviceBulletinData = await sendRequestAndReceiveResponse(
            JSON.stringify({
                'ClassificationId': SelectedProductNames[0],
                'ClassificationType': 'productname'
            }), retrieveServiceBulletinsEndPoint);
        dispatch({ type: SERVICE_BULLETIN_DATA, serviceBulletinData });
    },
    UpdateSelectedProductModel: (SelectedProductModels: any) => async (dispatch: any, getState: any) => {
        dispatch({ type: UPDATE_SELECTED_PRODUCTMODEL, SelectedProductModels });
        const serviceBulletinData = await sendRequestAndReceiveResponse(
            JSON.stringify({
                'ClassificationId': SelectedProductModels[0],
                'ClassificationType': 'productmodel'
            }), retrieveServiceBulletinsEndPoint);
        dispatch({ type: SERVICE_BULLETIN_DATA, serviceBulletinData });
    },
    selectBulletin: (selectedBulletin: any) => async (dispatch: any, getState: any) => {

        dispatch({ type: LOADING_BULLETIN_DETAIL });
        if (selectedBulletin.serviceBulletinURL != '') {
            if (selectedBulletin.serviceBulletinURL.includes('docushare')) {
                const requestBody = {
                    TicketGrantingTicketUrl: window.atob(loadFromLocalStorage("TGT")),
                    ServiceName: 'http://trl.trimble.com/docushare/sso_login?location=' + selectedBulletin.serviceBulletinURL
                };
                const token: string = loadFromLocalStorage('AuthToken');
                const encodedToken = 'Bearer ' + token;
                const headerDict: any = {
                    'Authorization': encodedToken,
                    'Content-Type': 'application/json'
                };
                const response: any = await fetch(getServiceTicketEndpoint, {
                    headers: new Headers(headerDict),
                    body: JSON.stringify(requestBody),
                    method: 'POST'
                });
                const responseData = await response.json();
                console.log(responseData);
                if (response.body != undefined) {
                    const url = `https://trl.trimble.com/docushare/sso_login?location=${  selectedBulletin.serviceBulletinURL  }&ticket=${  responseData.serviceTicket}`;
                    console.log(url);
                    selectedBulletin.serviceBulletinURL = url;

                }
            }
            else {
                if (selectedBulletin.isauthenticated != true) {
                    const BulletinUrl = await sendRequestAndReceiveResponse(
                        toUrlLookupBody(selectedBulletin.serviceBulletinURL)
                        , getServiceBulletinsURLEndPoint);
                    selectedBulletin.serviceBulletinURL = BulletinUrl.presignedURL;
                    selectedBulletin.isauthenticated = true;

                    console.log(BulletinUrl.presignedURL);
                }
            }
        }
        dispatch({ type: SERVICE_BULLETIN_DETAIL, selectedBulletin });
    },
    unSelectBulletin: () => async (dispatch: any, getState: any) => {
        dispatch({ type: UNSELECT_BULLETIN });
    },

    Loadingbulletindetails: () => async (dispatch: any, getState: any) => {
        dispatch({ type: LOADING_BULLETIN_DETAIL });
    },
    Completedloadingbulletindetails: () => async (dispatch: any, getState: any) => {
        dispatch({ type: LOADING_BULLETIN_DETAIL_DONE });
    },
    LoadServiceBulletin: (serialNumber: any) => async (dispatch: any, getState: any) => {
        dispatch({ type: LOAD_SERVICE_BULLETIN, serialNumber });
    },
    StopLoading: () => async (dispatch: any, getState: any) => {
        dispatch({ type: STOP_LOADING });
    },
    ClearViewBulletinData: () => async (dispatch: any, getState: any) => {
        dispatch({ type: CLEAR_VIEW_BULLETIN_STORE });
    },
    ClearBulletinList: () => async (dispatch: any, getState: any) => {
        dispatch({ type: CLEAR_BULLETIN_LIST });
    },
    LoadServiceBulletinforNumber: (bulletinNumber: any) => async (dispatch: any, getState: any) => {
        dispatch({ type: LOAD_SERVICE_BULLETIN_NUMBER, bulletinNumber });
    },
    filterBulletin: (filtervalue: any, bulletindata: any) => async (dispatch: any, getState: any) => {
        console.log(filtervalue);
        console.log(bulletindata);
        dispatch({ type: UPDATE_BULLETIN_DATA, bulletindata });
    },
}

export const reducer = (state: any, action: any) => {
    state = state || initialState;

    switch (action.type) {
        case UPDATE_FAMILIES:
            return {
                ...state,
                families: action.families
            };
        case UPDATE_SELECTED_FAMILY:
            return {
                ...state,
                selectedFamily: action.selectedFamilies,
                selectedProductName: undefined,
                selectedProductModel: undefined,
                isBulletinLoading: true,
                selectedBulletin: undefined,
                serialNumber: '',
                bulletinNumber: ''
            };
        case UPDATE_SELECTED_PRODUCTNAME:
            return {
                ...state,
                selectedProductName: action.SelectedProductNames,
                selectedProductModel: undefined,
                isBulletinLoading: true,
                selectedBulletin: undefined,
                serialNumber: '',
                bulletinNumber: ''

            };
        case UPDATE_SELECTED_PRODUCTMODEL:
            return {
                ...state,
                selectedProductModel: action.SelectedProductModels,
                isBulletinLoading: true,
                selectedBulletin: undefined,
                serialNumber: '',
                bulletinNumber: ''
            };
        case UPDATE_ALL_BULLETIN_CLASSIFICATION:
            return {
                ...state,
                selectedFamily: action.selectedFamily,
                selectedProductName: action.selectedProductName,
                selectedProductModel: action.selectedProductModel,
                allserviceBulletinData: action.serviceBulletin,
                filteredserviceBulletinData: action.serviceBulletin,
                isBulletinLoading: false,
            };
        case UPDATE_PRODUCTNAMES:
            return {
                ...state,
                productNames: action.productNames
            };
        case UPDATE_PRODUCTMODELS:
            return {
                ...state,
                productModels: action.productModels
            };
        case UPDATE_SERIAL_NUMBER:
            return {
                ...state,
                serialNumber: action.serialNumber,
                bulletinNumber: ''
            };
        case UPDATE_BULLETINS:
            return {
                ...state,
                allserviceBulletinData: action.serviceBulletin,
                filteredserviceBulletinData: action.serviceBulletin,
                isBulletinLoading: false,
            };
        case SERVICE_BULLETIN_DATA:
            return {
                ...state,
                allserviceBulletinData: action.serviceBulletinData,
                filteredserviceBulletinData: action.serviceBulletinData,
                isBulletinLoading: false,
            };
        case LOADING_BULLETIN_DETAIL:
            return {
                ...state,
                isBulletinDetailLoading: true
            };
        case LOADING_BULLETIN_DETAIL_DONE:
            return {
                ...state,
                isBulletinDetailLoading: false
            };
        case SERVICE_BULLETIN_DETAIL:
            return {
                ...state,
                isBulletinDetailLoading: false,
                selectedBulletin: action.selectedBulletin,
                isAuthenticatedOnce: true
            };
        case UNSELECT_BULLETIN: return {
            ...state,
            selectedBulletin: undefined,
        };
        case LOAD_SERVICE_BULLETIN:
            return {
                ...state,
                isBulletinLoading: true,
                serialNumber: action.serialNumber,
                selectedFamily: undefined,
                selectedProductName: undefined,
                selectedProductModel: undefined,
                selectedBulletin: undefined
            };
        case LOAD_SERVICE_BULLETIN_NUMBER:
            return {
                ...state,
                isBulletinLoading: true,
                bulletinNumber: action.bulletinNumber,
                selectedFamily: undefined,
                selectedProductName: undefined,
                selectedProductModel: undefined,
                selectedBulletin: undefined
            };
        case STOP_LOADING:
            return {
                ...state,
                isBulletinLoading: false
            };
        case UPDATE_BULLETIN_DATA:
            return {
                ...state,
                filteredserviceBulletinData: action.bulletindata
            };
        case CLEAR_VIEW_BULLETIN_STORE: {
            return initialState;
        }
        case CLEAR_BULLETIN_LIST: {
            return {
                ...state,
                allserviceBulletinData: undefined,
                filteredserviceBulletinData: undefined
            };
        }
        case UPDATE_BULLETIN_NUMBER: {
            return {
                ...state,
                bulletinNumber: action.bulletinNumber,
                serialNumber: ''
            };
        }
    }

    return state;
};
